import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import { RouteConfig } from 'vue-router';
import { asyncRoutes, constantRoutes } from '@/router/paths';
import store from '@/store';
import { filterAsyncRoutes, AppRoleType } from '@/utils/permission';

export class UserTokenPermission {
  public tokenNotExisted: boolean = false;
  public tokenExpired: boolean = false;
  public unauthenticated: boolean = false;

  constructor(
    tokenNotExisted: boolean = false,
    tokenExpired: boolean = false,
    unauthenticated: boolean = false
  ) {
    this.tokenNotExisted = tokenNotExisted;
    this.tokenExpired = tokenExpired;
    this.unauthenticated = unauthenticated;
  }
}

export interface IPermissionState {
  routes: RouteConfig[];
  dynamicRoutes: RouteConfig[];
  userTokenPermission: UserTokenPermission;
}

@Module({ dynamic: true, store, name: 'permission' })
class Permission extends VuexModule implements IPermissionState {
  public routes: RouteConfig[] = [];
  public dynamicRoutes: RouteConfig[] = [];
  public userTokenPermission = new UserTokenPermission();

  @Mutation
  private SET_ROUTES(routes: RouteConfig[]) {
    this.routes = constantRoutes.concat(routes);
    this.dynamicRoutes = routes;
  }

  @Mutation
  private SET_USER_TOKEN_PERMISSON(userTokenPermission: UserTokenPermission) {
    this.userTokenPermission = userTokenPermission;
  }

  @Action
  public GenerateRoutes(roles: string[]) {
    let accessedRoutes;
    if (roles.includes(AppRoleType.ADMIN as string)) {
      accessedRoutes = asyncRoutes;
    } else {
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
    }
    this.SET_ROUTES(accessedRoutes);
  }

  @Action SetUserTokenPermission(userTokenPermission: UserTokenPermission) {
    this.SET_USER_TOKEN_PERMISSON(userTokenPermission);
  }

  @Action ResetUserTokenPermission() {
    this.SET_USER_TOKEN_PERMISSON(new UserTokenPermission());
  }
}

export const PermissionModule = getModule(Permission);
